/**
 * Sanitizes HTML content for safe display in the calendar
 * - Converts URLs to clickable links
 * - Preserves line breaks
 * - Removes potentially dangerous HTML
 * - Strips the '>' prefix Google Calendar inserts before URLs
 */
export function sanitizeAndLinkifyDescription(text: string | null | undefined): string {
    if (!text) {
        return '<span class="cal-description-placeholder">No description</span>';
    }

    // Do not pre-strip here — stripping is done after we know the content type below
    let cleaned = text;

    // If the text already contains HTML tags, sanitize and return it
    const hasHtmlTags = /<[^>]+>/.test(cleaned);

    if (hasHtmlTags) {
        let sanitized = cleaned
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/on\w+\s*=\s*["'][^"']*["']/gi, '')
            .replace(/javascript:/gi, '');

        // Ensure all links open in a new tab with proper security attributes
        sanitized = sanitized.replace(
            /<a\s+([^>]*href=["'][^"']*["'][^>]*)>/gi,
            '<a $1 target="_blank" rel="noopener noreferrer">'
        );

        return sanitized;
    }

    // Plain text: HTML-escape, preserve line breaks, then linkify URLs
    let result = cleaned
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    result = result.replace(/\n/g, '<br>');

    const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;
    result = result.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

    return result;
}

